import React, {Component} from 'react';
import Schedule from './components/schedule';
import UserDashBoard from './containers';
import Notification from './components/notification'
import {LocaleProvider} from 'antd';
import {Menu, Icon, Dropdown, Avatar} from 'antd';
import {parseUsername, parseAvatarText} from './components/schedule/util';
import viVN from 'antd/lib/locale-provider/vi_VN';
import {purgeStoredState} from 'redux-persist';
import {randomColor} from 'randomcolor';
import {asyncSessionStorage} from 'redux-persist/storages';
import {connect} from 'react-redux';
import moment from 'moment';
import * as actions from './actions';
import * as srv from './services';
import './App.css';
import MediaQuery from 'react-responsive';
import Script from 'react-load-script';

const SubMenu = Menu.SubMenu;

let customProjects = [{
    id: 63,
    name: 'BẢO TRÌ THIẾT BỊ',
    description: 'bảo hành, bảo trì thiết bị iTracking',
    logo: 'http://itracking.vn/images/logo.png',
    logoName: 'iTracking'
},
    {
        id: 65,
        name: 'SMARTBIKE - BẢO TRÌ THIẾT BỊ',
        description: 'bảo hành, bảo trì thiết bị SmartBike',
        logo: 'http://smartbike.vn/public/images/Ui-new/logo_smartbike.png',
        logoName: ''
    }];

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            calendarView: 'week',
            curSettingItems: ['setting:calendar', 'setting:calendar:week'],
            curIssueID: 0,
            visible: false,
            notiLimit: 5,
            layoutPointer: true,
            cantPushNoti: true,
            dropdownVisible: false,
        };

        this.handleLogout = this
            .handleLogout
            .bind(this);

        this.handleChangeState = this.handleChangeState.bind(this);
        this.setZeroIssueID = this.setZeroIssueID.bind(this);
    }

    handleChangeState(value, name) {
        if (value) {
            this.setState({
                [name]: value
            });
        }
    }

    getNotiPermission() {
        let permission = Notification.permission;

        if (permission === 'default') {
            Notification.requestPermission().then(function (result) {
                if (result === 'denied') {
                    this.setState({cantPushNoti: false});
                }

                if (result === 'default') {
                    this.setState({cantPushNoti: false});
                }
            });
        } else if (permission === 'denied') {
            this.setState({cantPushNoti: false});
        }

        if (!("Notification" in window)) {
            this.setState({cantPushNoti: false});
        }
    }

    async componentWillMount() {
        //this.getNotiPermission();
        const {route} = this.props;

        if (route && route.match) {
            const {issueID} = route.match.params;
            if (issueID && parseInt(issueID) > 0) {
                this.setState({calendarView: 'dialog', curIssueID: parseInt(issueID)});
            }
        }

        if (this.props.usersMap.size === 0) {
            const query = 'read/' + customProjects[0].id;
            const dataUsers = await srv.readUsers(query);
            if (dataUsers.users) {
                dataUsers.users.map((user) => {
                    if (!user.color) {
                        user.color = randomColor({luminosity: 'dark'});
                    }
                });
            }

            let now = moment();
            let strNow = now.format('DD-MM-YYYY');
            const dataIssues = await srv.getAllIssues(customProjects[0].id, this.props.token, 'week', strNow);
            if (dataIssues.status === 401) {
                alert("Đã hết phiên làm việc, vui lòng đăng nhập lại!");
                this.props.dispatch(actions.removeToken());
            }

            this.props.dispatch(actions.setProjects(customProjects));
            this.props.dispatch(actions.setCurrentProject(customProjects[0].id));

            this.props.dispatch(actions.getIssues(dataIssues.issues ? dataIssues.issues : []));
            this.props.dispatch(actions.getIssuesMap(dataIssues.issues ? dataIssues.issues : []));
            this.props.dispatch(actions.setNotis(dataIssues.notifications ? dataIssues.notifications : []));
            this.props.dispatch(actions.setNotiCount(dataIssues.notiCount ? dataIssues.notiCount : 0));

            this.props.dispatch(actions.selectUser(dataUsers.users));
            this.props.dispatch(actions.selectUserMap(dataUsers.users));

            this.props.dispatch(actions.getOverviewByTrackers(dataIssues.trackers ? dataIssues.trackers : []));
            this.props.dispatch(actions.getTrackersMap(dataIssues.trackers ? dataIssues.trackers : []));
        }
    }

    componentDidMount() {
        // if (this.state.cantPushNoti) {
        //     let notification = new Notification("Hi there!");
        //     console.log('notification : ',notification);
        // }  else {
        //     console.log('false ---------------------------------');
        // }
    }

    async handleLogout() {
        let {token} = this.props;
        if (token !== "") {
            await this.props.dispatch(actions.removeToken());
            await purgeStoredState({
                storage: asyncSessionStorage
            }, ["token", "account", "getUser", "events"]).then(() => {
                window
                    .location
                    .reload();
            }).catch(() => {
                console.log('purge of someReducer failed')
            });
        }
    }

    handleSelectMenuSetting = (e) => {
        if (e.key === 'logout') {
            this.handleLogout();
            return;
        }


        let arrKey = e.key.split(':');
        let curSettingItems = this.state.curSettingItems;
        if (arrKey.length === 3) {
            if (curSettingItems && curSettingItems.length > 0) {
                curSettingItems = curSettingItems.map((curSettingItem) => {
                    let arrKeyItem = curSettingItem.split(':');
                    if (arrKeyItem.length === 3) {
                        if (arrKeyItem[1] === 'calendar') {
                            return e.key;
                        }
                    }

                    return curSettingItem;
                });

            } else {
                curSettingItems = [e.key];
            }

            this.setState({
                curSettingItems,
                calendarView: arrKey[1] === 'calendar' ? arrKey[2] : this.state.calendarView,
                layoutPointer: true,
                dropdownVisible: false,
            });

        } else {
            if (curSettingItems && curSettingItems.length > 0) {
                curSettingItems = curSettingItems.map((curSettingItem) => {
                    let arrKeyItem = curSettingItem.split(':');
                    if (arrKeyItem.length === 2) {
                        return e.key;
                    }

                    return curSettingItem;
                });
            } else {
                curSettingItems = [e.key];
            }

            this.setState({
                curSettingItems,
                layoutPointer: true,
                dropdownVisible: false,
            });
        }
    };

    renderViewSetting() {
        return this.state.curSettingItems.map((curSettingItem) => {
            let arrCurSettingItem = curSettingItem.split(':');

            if (arrCurSettingItem && arrCurSettingItem.length === 2 && arrCurSettingItem[1] === 'calendar') {
                let user = this.props.account.user;
                if (!user.groups || user.groups === null || user.groups.length === 0) {
                    return null;
                }

                let isManager = !!user.groups['Manager'];
                if (isManager) {
                    return <Menu.ItemGroup key="group:setting:calendar" title="View Setting">
                        <Menu.Item key="setting:calendar:day">
                            <Icon type="credit-card" style={{
                                position: 'relative',
                                paddingRight: '10px',
                                fontSize: '16px',
                            }}/>
                            Day
                        </Menu.Item>
                        <Menu.Item key="setting:calendar:week">
                            <Icon type="layout" style={{
                                position: 'relative',
                                paddingRight: '10px',
                                fontSize: '16px',
                            }}/>
                            Week
                        </Menu.Item>
                        <Menu.Item key="setting:calendar:maps">
                            <Icon type="compass" style={{
                                position: 'relative',
                                paddingRight: '10px',
                                fontSize: '16px',
                            }}/>
                            Maps
                        </Menu.Item>
                    </Menu.ItemGroup>;
                }

                return <Menu.ItemGroup key="group:setting:calendar" title="View Setting">
                    <Menu.Item key="setting:calendar:day">
                        <Icon type="credit-card" style={{
                            position: 'relative',
                            paddingRight: '10px',
                            fontSize: '16px',
                        }}/>
                        Day
                    </Menu.Item>
                    <Menu.Item key="setting:calendar:week">
                        <Icon type="layout" style={{
                            position: 'relative',
                            paddingRight: '10px',
                            fontSize: '16px',
                        }}/>
                        Week
                    </Menu.Item>
                </Menu.ItemGroup>;
            }

            return null;
        });
    }

    setZeroIssueID() {
        this.setState({curIssueID: 0});
    }

    renderComponent() {
        for (let index = 0; index < this.state.curSettingItems.length; index++) {
            let curSettingItem = this.state.curSettingItems[index];
            let arrCurSettingItem = curSettingItem.split(':');// }

            if (arrCurSettingItem && arrCurSettingItem.length === 2 && arrCurSettingItem[1] === 'calendar') {
                return <LocaleProvider locale={viVN}>
                            <Schedule calendarView={this.state.calendarView}
                                    curIssueID={this.state.curIssueID}
                                    setZeroIssueID={this.setZeroIssueID}
                                    notiLimit={this.state.notiLimit}/>
                        </LocaleProvider>;
            } else {
                return <UserDashBoard logout={this.handleLogout}/>;
            }
        }
    }

    render() {
        let fullname = '';
        let userColor = '';

        if (this.props.account.user) {
            fullname = parseUsername(this.props.account.user.firstname, this.props.account.user.lastname);

            const user = this.props.usersMap.get(this.props.account.user.id.toString());
            if (user && user.size > 0) {
                userColor = user.get('color');

                this.props.account.user.color = userColor;
            }
        }

        const menu = (
            <MediaQuery minWidth={1224}>
                {(matches) => {
                    if (matches) {
                        return <Menu
                            onClick={this.handleSelectMenuSetting}
                            selectedKeys={this.state.curSettingItems}
                            className='menu-setting'
                            style={{
                                borderBottom: 'none',
                                textAlign: 'left',
                                position: 'relative',
                                width: '350px',
                                paddingTop: '10px',
                                fontSize: '16px',
                                fontWeight: 500,
                                boxShadow: '0 1px 6px rgba(0,0,0,.2)',
                                borderRadius: '4px',
                            }}
                            multiple
                        >
                            <Menu.ItemGroup title="View">
                                <Menu.Item key="setting:user">
                                    <Icon type="user" style={{
                                        position: 'relative',
                                        paddingRight: '10px',
                                        fontSize: '16px',
                                        top: '-1px'
                                    }}/>
                                    User
                                </Menu.Item>
                                <Menu.Item key="setting:calendar">
                                    <Icon type="calendar" style={{
                                        position: 'relative',
                                        paddingRight: '10px',
                                        fontSize: '16px',
                                        top: '-1px'
                                    }}/>
                                    Calendar
                                </Menu.Item>
                            </Menu.ItemGroup>
                            {
                                this.props.account.user ? this.renderViewSetting() : null
                            }
                            <Menu.Divider/>
                            <Menu.Item key="logout">Đăng Xuất<Icon
                                style={{
                                    float: 'right',
                                    position: 'relative',
                                    right: '10px',
                                    top: '3px',
                                }} type="logout"/>
                            </Menu.Item>
                        </Menu>;
                    } else {
                        return <Menu
                            onClick={this.handleSelectMenuSetting}
                            selectedKeys={this.state.curSettingItems}
                            className='menu-setting'
                            style={{
                                borderBottom: 'none',
                                textAlign: 'left',
                                position: 'relative',
                                width: '350px',
                                paddingTop: '10px',
                                fontSize: '16px',
                                fontWeight: 500,
                                boxShadow: '0 1px 6px rgba(0,0,0,.2)',
                                borderRadius: '4px',
                            }}
                            multiple
                        >
                            <Menu.ItemGroup title="View">
                                <Menu.Item key="setting:user">
                                    <Icon type="user" style={{
                                        position: 'relative',
                                        paddingRight: '10px',
                                        fontSize: '16px',
                                        top: '-1px'
                                    }}/>
                                    User
                                </Menu.Item>
                                <Menu.Item key="setting:calendar">
                                    <Icon type="calendar" style={{
                                        position: 'relative',
                                        paddingRight: '10px',
                                        fontSize: '16px',
                                        top: '-1px'
                                    }}/>
                                    Calendar
                                </Menu.Item>
                            </Menu.ItemGroup>
                            <Menu.Divider/>
                            <Menu.Item key="logout">Đăng Xuất<Icon
                                style={{
                                    float: 'right',
                                    position: 'relative',
                                    right: '10px',
                                    top: '3px',
                                }} type="logout"/>
                            </Menu.Item>
                        </Menu>;
                    }
                }}
            </MediaQuery>
        );

        return (
            <div className="App">
                <Script
                    url="https://maps.google.com/maps/api/js?libraries=geometry,places&sensor=true&key=AIzaSyAjFOjSudu9OcOdN07krbHaj2Jlnjt_P8M&language=vi"
                />
                <div>
                    <div
                        style={{
                            float: 'right',
                            position: 'relative',
                            zIndex: 100,
                            width: '100%',
                            height: '50px',
                            transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
                            boxSizing: 'border-box',
                            boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
                            paddingLeft: '24px',
                            paddingRight: '24px',
                            backgroundColor: '#fff',
                        }}>
                        <div
                            className="avatar-setting"
                            style={{
                                float: 'right',
                                position: 'relative',
                                right: '-4px',
                                top: '8px',
                                zIndex: 150,
                                fontSize: '14px',
                                fontWeight: 500
                            }}>
                            <Dropdown
                                trigger={['click']}
                                overlay={menu}
                                placement={'bottomLeft'}
                                visible={this.state.dropdownVisible}
                                onVisibleChange={(visible) => {
                                    this.setState({
                                        layoutPointer: !visible,
                                        dropdownVisible: visible
                                    });
                                }}
                            >
                            <span>
                                <Avatar color={'#fff'}
                                        style={{
                                            cursor: 'pointer',
                                            backgroundColor: userColor.length > 0 ? userColor : ''
                                        }}>
                                    {parseAvatarText(fullname)}
                                </Avatar>
                            </span>
                            </Dropdown>
                        </div>

                        <Notification handleChangeState={this.handleChangeState}/>

                    </div>
                    <div style={{
                        pointerEvents: this.state.layoutPointer ? 'auto' : 'none'
                    }}>
                        {
                            this.props.account.user ? this.renderComponent() : null
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(({account, usersMap, token}) =>
    ({account, usersMap, token}))(App);



// WEBPACK FOOTER //
// ./src/App.js